import React, { useCallback } from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import getEnvConfig from '../../../../utils/config/env';
import { selectShopCurrent } from '../../../shops/features/shops/store/shopSlice';
import { useAppSelector } from '../../../../store';

export enum BroadcastType {
    MASS = 'mass',
    AUTO = 'auto',
}

interface CreateOrEditButtonProps {
    type: BroadcastType;
}

const PUBLIC_PATH = getEnvConfig().PUBLIC_PATH;

export const CreateOrEditButton: React.FC<CreateOrEditButtonProps> = ({
    type,
}) => {
    const navigate = useNavigate();

    const current = useAppSelector(selectShopCurrent);

    const handleClick = useCallback(() => {
        switch (type) {
            case BroadcastType.MASS:
                navigate(
                    `${PUBLIC_PATH}/crm/mass-broadcasts/${current.id}/create`
                );
                break;
            case BroadcastType.AUTO:
                navigate(
                    `${PUBLIC_PATH}/crm/auto-broadcasts/${current.id}/settings`
                );
                break;
        }
    }, [navigate, current.id, type]);

    const renderTitle = useCallback(() => {
        switch (type) {
            case BroadcastType.MASS:
                return 'Создать рассылку';
            case BroadcastType.AUTO:
                return 'Настроить рассылки';
        }
    }, [type]);

    return (
        <Button
            type='primary'
            icon={type === BroadcastType.AUTO ? null : <PlusOutlined />}
            onClick={handleClick}
        >
            {renderTitle()}
        </Button>
    );
};
